import tree from "../../../components/tree.vue";
import MaintenanceReminder from "./MaintenanceReminder/MaintenanceReminder.vue"
import MaintenanceOrder from "./MaintenanceOrder/MaintenanceOrder.vue"

export default {
    name: "MaintenanceManagement",
    components: { tree, MaintenanceReminder, MaintenanceOrder },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            id: '',
            activeName: 'first',
        }
    },
    created() {
        
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        initQuery(item) {
            this.orgId = item.id
            if (this.activeName == 'first') {
                if (this.$route.params.ExpirationId) {
                    this.$refs.TabRepair.formInline.maintainState = this.$route.params.ExpirationId
                }
                this.$refs.TabRepair.orgId = item.id
                this.$refs.TabRepair.getReminderList()
            } else {
                this.$nextTick(() => {
                    this.$refs.TabMaintenance.orgId = item.id
                    this.$refs.TabMaintenance.getOrderList()
                })
            }
        },
        nodeClick(val) {
            if (this.activeName == 'first') {
                this.$refs.TabRepair.orgId = val.label
                this.$refs.TabRepair.getReminderList()
            } else {
                this.$nextTick(() => {
                    this.$refs.TabMaintenance.orgId = val.label
                    this.$refs.TabMaintenance.getOrderList()
                })
            }
        },
        handleClick(event) {
            console.log(event)
            this.activeName = event.name
            if (this.activeName == 'first') {
                this.$refs.TabRepair.getReminderList()
            } else {
                this.$nextTick(() => {
                    this.$refs.TabMaintenance.orgId = this.orgId
                    this.$refs.TabMaintenance.getOrderList()
                })

            }
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}